export default "__VITE_ASSET__DtNRFC8i__"